import { CarouselImages } from '@/shared/ui/CarouselImages/ui/CarouselImages.jsx'
import './ui/CarouselImages.scss'
export default CarouselImages
